import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { supabase } from './supabaseClient';

function AuthForm({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const signUp = async () => {
    try {
      setLoading(true);
      setError('');
      const { error } = await supabase.auth.signUp({ email, password });
      if (error) {
        setError(`Sign Up Error: ${error.message}`);
      } else {
        alert('Sign Up Successful! Please check your email for confirmation.');
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const logIn = async () => {
    try {
      setLoading(true);
      setError('');
      const { error } = await supabase.auth.signInWithPassword({ email, password });
      if (error) {
        setError(`Log In Error: ${error.message}`);
      }
    } catch (err) {
      setError('An unexpected error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 px-4">
      <div className="bg-white border border-lattice-card-border rounded-xl shadow-sm p-8">
        <h2 className="text-center text-2xl font-bold text-lattice-dark mb-8">Sign Up / Log In</h2>

        {error && (
          <div className="mb-5 px-4 py-3 bg-red-50 border border-red-200 rounded-lg">
            <p className="text-red-700 text-sm">{error}</p>
          </div>
        )}

        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (e.nativeEvent.submitter.name === 'signup') {
              signUp();
            } else {
              logIn();
            }
          }}
        >
          <div className="mb-4">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              className="w-full px-4 py-3 text-base border border-lattice-card-border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-lattice-green focus:border-transparent disabled:opacity-50 transition-shadow"
            />
          </div>

          <div className="mb-6">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              className="w-full px-4 py-3 text-base border border-lattice-card-border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-lattice-green focus:border-transparent disabled:opacity-50 transition-shadow"
            />
          </div>

          <div className="flex gap-3 mb-5">
            <button
              type="submit"
              name="login"
              disabled={loading}
              className="flex-1 py-3 bg-lattice-green hover:bg-lattice-green-hover text-lattice-btn-text rounded-lg font-semibold text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Processing...' : 'Log In'}
            </button>

            <button
              type="submit"
              name="signup"
              disabled={loading}
              className="flex-1 py-3 border border-lattice-green text-lattice-green hover:bg-lattice-green hover:text-lattice-btn-text rounded-lg font-semibold text-base transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Processing...' : 'Sign Up'}
            </button>
          </div>
        </form>

        <button
          type="button"
          onClick={() => navigate('/reset-password')}
          className="w-full py-2.5 text-lattice-muted text-sm hover:text-lattice-dark transition-colors"
        >
          Forgot your password?
        </button>
      </div>
    </div>
  );
}

export default AuthForm;
